import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MenuState } from './menu.state';

export namespace MenuSelectors {
  const state = createFeatureSelector<MenuState.State>(MenuState.key);

  export const getMenu = createSelector(
    state,
    (state: MenuState.State) => state.menu,
  );
}
